import {
  faArrowLeftLong,
  faGraduationCap,
  faCoins,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { ADD, baseURL } from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDataRefresh } from "../../../Pages/context/DataRefreshContext";

export default function Add() {
  const axiosPrivate = useAxiosPrivate();
  const [Loding, setLoding] = useState(false);
  const Navigate = useNavigate();
  const { triggerRefresh } = useDataRefresh();

  const [data, setData] = useState({
    academicName: "",
    academicType: "",
    sortOrder: 0,
    price: "",
    description: "",
    subtitle: "",
  });
  const [image, setImage] = useState(null);

  function handleChange(e) {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  async function handleSubmit(nav, save) {
    setLoding(true);

    try {
      const formData = new FormData();
      formData.append("academicName", data.academicName);
      formData.append("academicType", data.academicType);
      formData.append("sortOrder", data.sortOrder);
      formData.append("price", data.price);
      formData.append("description", data.description);
      formData.append("subtitle", data.subtitle);
      formData.append("save", save ? "1" : "0");
      if (image) {
        formData.append("image", image);
      }

      const response = await axiosPrivate.post(`${baseURL}/${ADD}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("تم الحفظ بنجاح");

      setData({
        academicName: "",
        academicType: "",
        sortOrder: 0,
        price: "",
        description: "",
        subtitle: "",
      });
      setImage(null);

      // Trigger refresh to update the data in StudyLevels
      triggerRefresh();

      if (nav) {
        setTimeout(() => {
          Navigate("/DashboardLayout/content/academic");
        }, 500); // Small delay to ensure refresh is triggered
      }
    } catch (error) {
      console.error("حدث خطأ:", error);

      if (error.response && error.response.status === 400) {
        toast.error("لم يتم الحفظ، قد تكون البيانات مكررة أو غير صحيحة");
      } else {
        toast.error("حدث خطأ أثناء الحفظ، حاول مرة أخرى لاحقاً");
      }
    } finally {
      setLoding(false);
    }
  }

  return (
    <>
      {Loding && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/content/academic"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3 text-end"
            icon={faArrowLeftLong}
          />
        </Link>
        <h2 className="fw-bold">إضافة مرحلة دراسية</h2>
        <div className="d-flex align-items-center mb-5">
          <Form onSubmit={(e) => e.preventDefault()} className="Form w-75">
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="academicName"
                value={data.academicName}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faGraduationCap} />
                <span className="textinpout">اسم المرحلة</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="mb-5" controlId="city">
              <Form.Label>نوع المرحلة</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="academicType"
                value={data.academicType}
                onChange={handleChange}
              >
                <option value="">---</option>
                <option value="general">عام</option>
                <option value="azhar">ازهر</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="price"
                value={data.price}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faCoins} />
                <span className="textinpout">سعر المرحلة (الافتراضي: 150)</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="sortOrder"
                value={data.sortOrder}
                onChange={handleChange}
                placeholder=" "
                min="0"
              />
              <Form.Label>
                <span className="textinpout">ترتيب العرض</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="subtitle"
                value={data.subtitle}
                onChange={handleChange}
                placeholder=" "
              />
              <Form.Label>
                <span className="textinpout">العنوان الفرعي للمرحلة (مثال: ثانوي عام / ثانوية أزهرية) (اختياري)</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                as="textarea"
                rows={3}
                className="inpoutFeald"
                name="description"
                value={data.description}
                onChange={handleChange}
                placeholder=" "
                style={{ height: "auto", paddingTop: "25px" }}
              />
              <Form.Label>
                <span className="textinpout">وصف المرحلة الدراسية (اختياري)</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="mb-5 text-end">
              <Form.Label className="small text-muted mb-2">صورة المرحلة الدراسية (اختياري):</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </Form.Group>

            <div className="d-flex gap-2">
              <Button
                onClick={() => handleSubmit(true, false)}
                style={{ padding: "0px 40px" }}
                className="custom-brand-btn-dhash"
              >
                إضافة
              </Button>

              <Button
                onClick={() => {
                  setData({
                    academicName: "",
                    academicType: "",
                    sortOrder: 0,
                    price: "",
                    description: "",
                    subtitle: "",
                  });
                  setImage(null);
                }}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "var(--brand-100)",
                }}
                type="reset"
                className="custom-reset-btn"
              >
                مسح المدخلات
              </Button>

              <Button
                onClick={() => handleSubmit(true, true)}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "transparent",
                  color: "black",
                }}
                className="custom-reset-btn"
              >
                حفظ كمسودة
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
